angular.module('backOffice').directive('superUserPanel', () => ({
    scope: {
        isSuperUser: '=',
    },
    template: require('./superUserPanelTemplate.html'),
}));
